module.exports = __webpack_public_path__ + "static/media/leaf.c2f375dd.png";